export default function ({ store }) {
	return store.dispatch('getCategories')
}
